module.exports = __webpack_public_path__ + "ca4068d1d5a9589d4ad48fa3f344bef8.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/virtual-sports/assets/vfcc.png
// module id = 1781
// module chunks = 2